Application.Wordmark.Position = {
    ui: {
        container: '.js-wordmark-position',
        controller: '.js-wordmark-position__controller',
        controllerPosition: '.js-wordmark-position__controller-position',
        preview: '.js-wordmark-position__preview',
        previewLogo: '.js-wordmark-position__preview-logo',
        color: '.js-wordmark-position__color',
    },
    ready: function () {

        var self = this;

        if (!$(this.ui.container).length){
            return;
        }

        // update image sizes
        // init
        $(this.ui.container).each(function(){
            self.resize($(this));
        });

        // update preview position
        // bind on change
        $(this.ui.controller).change(function(){
            self.update($(this).closest(self.ui.container));
        });
        // init
        $(this.ui.container).each(function(){
            self.update($(this));
        });

        // update color
        // bind on change
        $(this.ui.color).change(function(){
            self.updateColor($(this).closest(self.ui.container));
        });
        // init
        $(this.ui.container).each(function(){
            self.update($(this));
        });

    },
    resize: function($container){

        var size = {
            w: 480,
            h: 360,
        };

        var $controller = $container.find(this.ui.controller);
        var $preview = $container.find(this.ui.preview);
        var $img = $controller.find('img');

        // load image size
        this.getImageDimensions($img.attr('src'), function(w, h){
            var ratio = w / h;
            if (size.w / size.h > ratio){
                $controller.css({
                    height: size.h + 'px',
                    width: (size.h * ratio) + 'px'
                }).addClass('sized');
                $preview.css({
                    height: size.h + 'px',
                    width: (size.h * ratio) + 'px'
                }).addClass('sized');
            }else{
                $controller.css({
                    height: (size.w / ratio) + 'px',
                    width: size.w + 'px'
                }).addClass('sized');
                $preview.css({
                    height: (size.w / ratio) + 'px',
                    width: size.w + 'px'
                }).addClass('sized');
            }
        });

    },
    getImageDimensions: function(src, callback){

        var img = new Image();
        img.onload = function() {
            callback(img.width, img.height);
        }
        img.src = src;

    },
    update: function($container){

        // find logo element
        var $logo = $container.find(this.ui.previewLogo);

        // remove all classes
        var positionClasses = {
            br: 'wordmark-logo__logo--right-bottom',
            bl: 'wordmark-logo__logo--left-bottom',
            tr: 'wordmark-logo__logo--right-top',
            tl: 'wordmark-logo__logo--left-top',
            c: 'wordmark-logo__logo--center'
        };
        $logo.removeClass(_.values(positionClasses).join(' '));

        // add active class
        var $active = $container.find(this.ui.controllerPosition).filter(':checked');
        if ($active.val() && typeof positionClasses[$active.val()] != 'undefined'){
            $logo.addClass(positionClasses[$active.val()]);
        }

    },
    updateColor: function ($container) {

        // find current value
        var color = $container.find(this.ui.color).filter(':checked').val();

        // find logo element
        var $logo = $container.find(this.ui.previewLogo);

        // set color
        $logo.attr('data-color', color);

    }
};